import { getSelfPlusAdmins } from '@sp/data/bif';
import { USER_PROFILE_CARD_MEMBERS_MODEL } from '@sp/data/user-profile-card';
import { createResource } from '@sp/util/helpers';
import { sample } from 'effector';

export const SELFPLUS_ADMINS_MODEL = createResource(getSelfPlusAdmins);

// Init UserProfileCard
{
  const users = USER_PROFILE_CARD_MEMBERS_MODEL.users.createItemAdapter('selfplusAdmins');

  sample({
    source: SELFPLUS_ADMINS_MODEL.$data.map(admins => admins ?? []),
    target: users.set,
  });
}
